import { render } from "./DriverEntityLink.vue?vue&type=template&id=0bc20944&scoped=true"
import script from "./DriverEntityLink.vue?vue&type=script&lang=js"
export * from "./DriverEntityLink.vue?vue&type=script&lang=js"

import "./DriverEntityLink.vue?vue&type=style&index=0&id=0bc20944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc20944"]])

export default __exports__